import { useState } from 'react'

export const useChatUI = () => {
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  const [turnstileToken, setTurnstileToken] = useState(null)

  const clearError = () => setError(null)
  const setErrorMessage = (message) => setError(message)

  return {
    error,
    loading,
    turnstileToken,
    setError: setErrorMessage,
    clearError,
    setLoading,
    setTurnstileToken,
  }
}
